import React from 'react'
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { Turnstile } from '@marsidev/react-turnstile'
import { setContactinfo, setContacterror } from '../slices/contactSlice';
import useCsrfToken from '../hooks/useCsrfToken';
import { Link } from 'react-router-dom'

export default function Eventcontact({ listing }) {
    const { csrfToken } = useCsrfToken();
    let params = useParams();
    let reflistingid = params.listingid;
    const dispatch = useDispatch();
    const contactInfo = useSelector((state) => state.contact.contactInfo);
    const contactError = useSelector((state) => state.contact.error);
    const [captchaPassed, setCaptchaPassed] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorDeliveringMessage, SetErrorDeliveringMessage] = useState('');
    const [errorDelivering, SetErrorDelivering] = useState(false);
    const [successDeliveringMessage, SetSuccessDeliveringMessage] = useState('');
    const [enablepayment, setEnablePayment] = useState(false);
    const [successDelivering, SetSuccessDelivering] = useState(false);
    const [leadid, setLeadId] = useState('');
    const [paymentRedirectCountdown, setPaymentRedirectCountdown] = useState(5);
    const [specialties, setSpecialties] = useState([]);
    const API_URL = process.env.REACT_APP_API_URL;
    const buybaseurl = process.env.REACT_APP_BUYNOW_BASE_URL;
    const paymentUrl = `${buybaseurl}/guest-buy-event/${reflistingid}/event/${leadid}`;
    const isMedicalEvent = listing.event_type === 'medico';

    const TURNSTILE_KEY = '0x4AAAAAABBf7H_LASwjWDgk';

    useEffect(() => {
        if (!isMedicalEvent) {
            return;
        }

        fetch(`${API_URL}/api/specialties`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.json())
            .then(data => setSpecialties(Array.isArray(data) ? data : Object.values(data)))
            .catch(error => console.error('Error fetching specialties:', error));
    }, [API_URL, csrfToken, isMedicalEvent]);

    useEffect(() => {
        if (!enablepayment || !successDelivering || listing.price === null || listing.price <= 0 || !leadid) {
            return;
        }

        setPaymentRedirectCountdown(5);

        const countdownInterval = setInterval(() => {
            setPaymentRedirectCountdown((previousCountdown) => {
                if (previousCountdown <= 1) {
                    clearInterval(countdownInterval);
                    window.location.href = paymentUrl;
                    return 0;
                }

                return previousCountdown - 1;
            });
        }, 1000);

        return () => clearInterval(countdownInterval);
    }, [enablepayment, successDelivering, listing.price, leadid, paymentUrl]);

    const handlePhoneInput = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length > 10) {
            e.target.value = value.slice(0, 10);
        } else {
            e.target.value = value;
        }
    };

    const handleEmailInput = (e) => {
        const value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, '');
        e.target.value = value;

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
            e.target.setCustomValidity('Por favor, ingrese una dirección de correo electrónico válida.');
        } else {
            e.target.setCustomValidity('');
        }
    };

    const handleEmailBlur = (e) => {
        console.log('handleEmailBlur');
        const value = e.target.value;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const invalidFeedback = e.target.nextElementSibling;
        if (!emailPattern.test(value)) {
            e.target.setCustomValidity('Por favor, ingrese una dirección de correo electrónico válida.');
            invalidFeedback.style.display = 'block';
        } else {
            e.target.setCustomValidity('');
            invalidFeedback.style.display = 'none';
        }
    };

    const handleSanitizedInput = (e) => {
        let value = e.target.value;
        // Remove HTML tags
        value = value.replace(/<\/?[^>]+(>|$)/g, '');
        // Replace ENTER with a period and space
        value = value.replace(/\r?\n|\r/g, '. ');
        // Remove script tags
        value = value.replace(/<script.*?>.*?<\/script>/gi, 'HAPHAPHAP');
        // Remove any other unwanted characters or tags
        value = value.replace(/<[^>]*>/g, '');
        value = value.replace(/&[^;]+;/g, '');
        e.target.value = value;
    };

    const handlePrivacyCheckbox = (e) => {
        const privacyCheckbox = document.getElementById('privacy');
        if (privacyCheckbox.checked) {
            setPrivacyAccepted(true);
        } else {
            setPrivacyAccepted(false);
        }
    };

    const Initcontact = (data) => {
        // console.log('data', data);
        dispatch(setContactinfo(data));
    }

    const handleSubmit = async (e) => {
        setIsLoading(true);
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);
        const data = {
            eventname: listing.title,
            eventdate: listing.fulleventdate,
            eventstart: listing.eventstartdate,
            eventend: listing.eventenddate,
            eventtype: listing.event_type,
            price: listing.price? listing.price : 0,
            name: formData.get('name'),
            lastname: formData.get('lastname'),
            tel: formData.get('tel'),
            email: formData.get('email'),
            email_confirmation: formData.get('email_confirmation'),
            city: formData.get('city'),
            state: formData.get('state'),
            institution: formData.get('institution'),
            howdid: formData.get('howdid'),
            visitortype: isMedicalEvent ? formData.get('visitortype') : '',
            specialty: isMedicalEvent ? formData.get('specialty') : '',
            license: isMedicalEvent ? formData.get('license') : '',
            captcharesponse: formData.get('cf-turnstile-response'),
            _token: csrfToken,
            listingid: reflistingid ? reflistingid : '',
            payment_link: paymentUrl ? paymentUrl : ''
        };
        Initcontact(data);

        try {
            const response = await fetch(`${API_URL}/api/sendmail/event`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();
            if (result.status === 'success') {
                SetErrorDeliveringMessage('');
                SetErrorDelivering(false);
                SetSuccessDeliveringMessage(result.message);
                SetSuccessDelivering(true);
                dispatch(setContacterror(false));
                setLeadId(result.leadid);
                form.reset();
                setIsLoading(false);
                requestAnimationFrame(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                });
                if(listing.price > 0 && listing.price != null) {
                    setEnablePayment(true);
                }
            } else {
                SetErrorDeliveringMessage(result.message);
                SetErrorDelivering(true);
                SetSuccessDelivering(false);
                dispatch(setContacterror(true));
                setIsLoading(false);
            }
        } catch (error) {
            SetErrorDeliveringMessage(error);
            SetErrorDelivering(true);
            SetSuccessDelivering(false);
            dispatch(setContacterror(true));
            setIsLoading(false);
        }
    };

    const handleCallBackTurnstile = (data) => {
        setCaptchaPassed(true);
    }

    const handleExpirationTurnstile = () => {
        setCaptchaPassed(false);
        console.log('Turnstile - expired');
    }

    return (
        <>
            <section className="section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="p-4 rounded shadow bg-inverted ms-lg-5">
                                <h4>Registro para evento - {listing.title}</h4>
                                <form className="mt-4" onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}>
                                    {!successDelivering && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <p>
                                                        Está iniciando el registro para el evento: <strong>{listing.title}</strong>
                                                    </p>
                                                    { listing.price !== null && listing.price > 0 && (
                                                    <div className='text-center mb-3 fw-bold text-success'>
                                                        Costo: $ {listing.price} MXN
                                                    </div>
                                                    )}
                                                    <div className='text-center small'>
                                                        <small className='small badge rounded-pill bg-primary text-light'>
                                                            {listing.eventstart}
                                                        </small>
                                                    </div>
                                                    <div className='text-center small mt-1 mb-4'>
                                                        <small className='small badge rounded-pill bg-secondary text-light'>
                                                            {listing.eventend}
                                                        </small>
                                                    </div>
                                                    <p>
                                                        <small className='text-muted'>
                                                            Por favor, complete el siguiente formulario para confirmar su asistencia. Recuerde que el registro es individual y no es transferible. También considere que los eventos tienen un cupo limitado y su registro no garantiza su asistencia.
                                                        </small>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    {/* <h5>Evento</h5>
                                                    <p>{listing.title}</p> */}
                                                    <div className="mb-3">
                                                        <label className="form-label fw-semibold">Evento</label>
                                                        <input name="eventname" id="name" type="text" className="form-control border-primary" placeholder="Su nombre:" defaultValue={listing.title} disabled readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 d-md-flex d-block justify-content-between gap-3">
                                                    <div className="mb-3 w-md-50 w-100">
                                                        <label className="form-label fw-semibold">Nombre(s) <span className="text-danger">*</span></label>
                                                        <input name="name" id="name" type="text" className="form-control border-muted" placeholder="Su nombre:" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.name : ''} />
                                                    </div>
                                                    <div className="mb-3 w-md-50 w-100">
                                                        <label className="form-label fw-semibold">Apellido(s) <span className="text-danger">*</span></label>
                                                        <input name="lastname" id="lastname" type="text" className="form-control border-muted" placeholder="Su nombre:" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.lastname : ''} />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 d-md-flex d-block justify-content-between gap-3">
                                                    <div className="mb-3 w-md-50 w-100">
                                                        <label className="form-label fw-semibold">Móvil a 10 dígitos <span className="text-danger">*</span></label>
                                                        <input name="tel" id="tel" type="tel" className="form-control border-muted" placeholder="Teléfono móvil:" onInput={(e) => { handlePhoneInput(e); handleSanitizedInput(e); }} defaultValue={contactError ? contactInfo.tel : ''} />
                                                    </div>
                                                    <div className="mb-3 w-100">
                                                        <label className="form-label fw-semibold">Correo electrónico <span className="text-danger">*</span></label>
                                                        <input name="email" id="email" type="email" className="form-control border-muted" placeholder="Correo electrónico:" onInput={(e) => { handleEmailInput(e); handleSanitizedInput(e); }} onBlur={handleEmailBlur} defaultValue={contactError ? contactInfo.email : ''} />
                                                        <div className="invalid-feedback">
                                                            Por favor, ingrese una dirección de correo electrónico válida.
                                                        </div>
                                                    </div>
                                                    <div className="mb-3 w-100">
                                                        <label className="form-label fw-semibold">Confirme correo electrónico <span className="text-danger">*</span></label>
                                                        <input name="email_confirmation" id="email_confirmation" type="email" className="form-control border-muted" placeholder="Correo electrónico nuevamente:" onInput={(e) => { handleEmailInput(e); handleSanitizedInput(e); }} onBlur={handleEmailBlur} defaultValue={contactError ? contactInfo.email_confirmation : ''} />
                                                        <div className="invalid-feedback">
                                                            Por favor, ingrese una dirección de correo electrónico válida.
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 d-md-flex d-block justify-content-between gap-3">
                                                    <div className="mb-3 w-md-50 w-100">
                                                        <label className="form-label fw-semibold">Ciudad <span className="text-danger">*</span></label>
                                                        <input name="city" id="city" type="text" className="form-control border-muted" placeholder="Ciudad:" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.city : ''} />
                                                    </div>
                                                    <div className="mb-3 w-md-50 w-100">
                                                        <label className="form-label fw-semibold">Estado <span className="text-danger">*</span></label>
                                                        <input name="state" id="state" type="text" className="form-control border-muted" placeholder="Estado:" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.state : ''} />
                                                    </div>
                                                    {(listing.event_type === 'comercial' || isMedicalEvent) && (
                                                        <div className="mb-3 w-md-50 w-100">
                                                            <label className="form-label fw-semibold">Empresa/Institución de procedencia</label>
                                                            <input name="institution" id="institution" type="text" className="form-control border-muted" placeholder="Institución:" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.institution : ''} />
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-md-12 d-md-flex d-block justify-content-between gap-3">
                                                    <div className="mb-3 w-md-50 w-100">
                                                        <label className="form-label fw-semibold">¿Cómo se enteró del evento? <span className="text-danger">*</span></label>
                                                        <select name="howdid" id="howdid" className="form-control border-muted" defaultValue={contactError ? contactInfo.howdid : ''} onInput={handleSanitizedInput}>
                                                            <option value="">Seleccione</option>
                                                            <option value="hospital">Dentro de Hospital</option>
                                                            <option value="radio">Radio</option>
                                                            <option value="tv">TV</option>
                                                            <option value="instagram">Instagram</option>
                                                            <option value="facebook">Facebook</option>
                                                            <option value="newspapers">Periódicos o revistas</option>
                                                            <option value="posters">Carteles</option>
                                                            <option value="billboards">Espectaculares o vallas</option>
                                                            <option value="email">Correo electrónico</option>
                                                            <option value="recommendation">Recomendación</option>
                                                        </select>
                                                    </div>
                                                    {isMedicalEvent && (
                                                        <div className="mb-3 w-md-50 w-100">
                                                            <label className="form-label fw-semibold">Tipo de participante <span className="text-danger">*</span></label>
                                                            <select name="visitortype" id="visitortype" className="form-control border-muted" defaultValue={contactError ? contactInfo.visitortype : ''} onChange={(e) => {
                                                                const specialtyField = document.getElementById('specialty');
                                                                const licenseField = document.getElementById('license');
                                                                if (e.target.value !== 'health') {
                                                                    specialtyField.disabled = true;
                                                                    licenseField.disabled = true;
                                                                    specialtyField.value = '';
                                                                    licenseField.value = '';
                                                                } else {
                                                                    specialtyField.disabled = false;
                                                                    licenseField.disabled = false;
                                                                }
                                                            }}>
                                                                <option value="">Seleccione</option>
                                                                <option value="health">Personal de la salud</option>
                                                                <option value="public">Público en general</option>
                                                                <option value="student">Estudiante</option>
                                                            </select>
                                                        </div>
                                                    )}
                                                </div>
                                                {isMedicalEvent && (
                                                    <div className="col-md-12 d-md-flex d-block justify-content-between gap-3">
                                                        <div className="mb-3 w-md-50 w-100">
                                                            <label className="form-label fw-semibold">Especialidad o área médica <span className="text-danger">*</span>
                                                            </label>
                                                            <select name="specialty" id="specialty" className="form-control border-muted" defaultValue={contactError ? contactInfo.specialty : ''}>
                                                                <option value="">Seleccione</option>
                                                                {specialties.map((specialty, index) => (
                                                                    <option key={specialty.id || index} value={specialty.title}>{specialty.title}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="mb-3 w-md-50 w-100">
                                                            <label className="form-label fw-semibold">Cédula profesional <span className="text-danger">*</span></label>
                                                            <input name="license" id="license" type="text" className="form-control border-muted" placeholder="Su cédula profesional:" onInput={handleSanitizedInput} defaultValue={contactError ? contactInfo.license : ''} />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-md-12 d-md-flex d-block justify-content-between gap-3">
                                                    <div className="mb-3 w-md-50 w-100 text-center">
                                                        <input name="privacy" id="privacy" type="checkbox" className="form-check-input border-black" defaultValue={contactError ? contactInfo.privacy : ''} required onChange={handlePrivacyCheckbox} />
                                                        <label className="form-label fw-semibold ps-2">
                                                            He leido y acepto el <Link to='/aviso-privacidad' target='_blank' className='text-secondary'>Aviso de Privacidad</Link>. <span className="text-danger">*</span>
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-12 text-center">
                                                    <Turnstile siteKey={TURNSTILE_KEY} onSuccess={handleCallBackTurnstile} onExpire={handleExpirationTurnstile} />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {captchaPassed && !isLoading && privacyAccepted && !successDelivering && (
                                        <div className="row mt-2">
                                            <div className="col-12">
                                                <div className="d-grid">
                                                    <button type="submit" id="submit" name="send" className="btn btn-primary">
                                                        {listing.price !== null && listing.price > 0  && (
                                                            <>
                                                            Guardar y proceder al pago 
                                                            </>
                                                        )}
                                                        {(listing.price === null || listing.price === 0) && (
                                                            <>
                                                            Registro
                                                            </>
                                                        ) }
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {isLoading && (
                                        <div className="spinner-border text-success mx-auto my-2 text-center" role="status">
                                            <span className="visually-hidden text-center">Registrando, espere...</span>
                                        </div>
                                    )}
                                    {errorDelivering && (
                                        <>
                                            <br />
                                            <div className="alert alert-warning alert-dismissible fade show" role="alert">
                                                <strong>No se pudo realizar el registro, error: </strong> {errorDeliveringMessage}
                                            </div>
                                        </>
                                    )}
                                    {successDelivering && (
                                        <>
                                            <br />
                                            {!enablepayment && (
                                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                                <strong>{successDeliveringMessage}</strong>
                                            </div>
                                            )}
                                            {enablepayment && listing.price !== null && listing.price > 0  && (
                                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                                    <strong>Su registro se ha creado, redireccionando a la pasarela de pago...</strong>
                                                    <br />
                                                    <span>Redireccionando en {paymentRedirectCountdown} segundos.</span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-100 mt-60">
                    <div className="row">
                        <div className="col-12">
                            {listing.rules && (
                                <>
                                    <h3 className='mt-3 small text-muted'>Reglas</h3>
                                    <div className='text-muted small' dangerouslySetInnerHTML={{ __html: listing.rules }} />
                                </>
                            )}
                            {listing.terms && (
                                <>
                                    <h3 className='mt-3 small text-muted'>Términos y condiciones</h3>
                                    <div className='text-muted small' dangerouslySetInnerHTML={{ __html: listing.terms }} />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
